import {confirmationActionTypes} from './../consts';

const callbackCache = {};

const boConfirm = (message, callback) => {
    return (dispatch, getState) => {
        !getState().confirmation.id && (() => {
            const id = new Date().getTime();
            Object.assign(callbackCache, {id: id, func: callback});
            dispatch({type: confirmationActionTypes.open, payload: {id, message}});
        })();
    }
};

const closeBoConfirmation = () => {
    return (dispatch, getState) => {
        getState().confirmation.id && (() => {
            Object.keys(callbackCache).forEach((key) => {
                delete callbackCache[key];
            });
            return callbackCache;
        })() && dispatch({type: confirmationActionTypes.close});
    }
};

const getCallbackCache = () => (callbackCache || {});

export {boConfirm as default, closeBoConfirmation, getCallbackCache}


// WEBPACK FOOTER //
// ./src/app/actions/confirmation.js